module.exports = __webpack_public_path__ + "img/pchomemap.9c135d4c.svg";